var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    zoomAndPan: "magnify",
    viewBox: "0 0 1440 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 767.21875 11.652344 L 221.527344 11.652344 C 130.898438 11.652344 56.996094 85.4375 56.996094 176.234375 L 56.996094 622.667969 C 56.996094 713.324219 130.761719 787.25 221.527344 787.25 L 767.21875 787.25 C 857.847656 787.25 931.75 713.460938 931.75 622.667969 L 931.75 176.234375 C 931.75 85.4375 857.988281 11.652344 767.21875 11.652344 Z M 875.535156 622.667969 C 875.535156 682.328125 827 731.015625 767.21875 731.015625 L 221.527344 731.015625 C 161.886719 731.015625 113.210938 682.464844 113.210938 622.667969 L 113.210938 176.234375 C 113.210938 116.574219 161.746094 67.882812 221.527344 67.882812 L 767.21875 67.882812 C 826.863281 67.882812 875.535156 116.4375 875.535156 176.234375 Z M 875.535156 622.667969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 1376.804688 136.871094 C 1362.546875 127.269531 1344.449219 125.351562 1328.679688 131.933594 L 1069.410156 238.363281 C 1048.980469 246.730469 1035.679688 267.03125 1035.679688 290.070312 L 1035.679688 512.808594 C 1035.679688 535.847656 1048.84375 556.011719 1069.410156 564.515625 L 1328.679688 670.945312 C 1334.988281 673.550781 1341.570312 674.785156 1348.152344 674.785156 C 1358.160156 674.785156 1368.304688 671.765625 1376.941406 666.007812 C 1392.300781 655.71875 1401.347656 638.300781 1401.347656 619.238281 L 1401.347656 183.640625 C 1401.210938 164.578125 1392.023438 147.15625 1376.804688 136.871094 Z M 1344.996094 616.632812 L 1091.757812 512.808594 C 1091.757812 512.808594 1091.757812 512.671875 1091.757812 512.671875 L 1091.757812 289.933594 C 1091.757812 289.933594 1091.757812 289.796875 1091.757812 289.796875 L 1344.996094 185.972656 Z M 1344.996094 616.632812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(48.709879, -28.12266, 28.148453, 48.754553, 30.499374, 793.370548)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500023 0.000000660554 L 27.075827 -0.00000973215 ",
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCamera);
export default __webpack_public_path__ + "static/media/no_camera.fd4c1d22ed1d1614f9aad3b6691afce5.svg";
export { ForwardRef as ReactComponent };